import { ILoginData, ILoginResponse, IResetPasswordData, IResetPasswordResponse } from 'types/auth';
import api, { authApi } from '../services/config/api';

export const postLogin = (data: ILoginData) => {
  const params = new URLSearchParams();

  if (data?.password !== '') {
    params.append('password', data?.password as string);
  }

  params.append('username', data.userName);
  params.append('grant_type', 'password');

  return authApi.post<ILoginResponse>('/oauth/token', params, {
    auth: { username: 'reactapp', password: '12345' },
  });
};

export const postResetPassword = (data: IResetPasswordData) => {
  const { user_recover } = data;

  return api.post<IResetPasswordResponse>(`/user/reset-password?user_recover=${user_recover}`);
};

export const postVerificationCode = (data: IResetPasswordData) => {
  const { user_recover, verification_code } = data;

  return api.post<IResetPasswordResponse>(
    `/user/verification-code?user_recover=${user_recover}&verification_code=${verification_code}`,
  );
};
export const postChangePassword = (data: IResetPasswordData) => {
  const { user_recover, password } = data;

  return api.post<IResetPasswordResponse>(
    `/user/change-password?user_recover=${user_recover}&password=${password}`,
  );
};

interface IChangePassword {
  old_password: string;
  new_password: string;
}

export const updatePassword = (data: IChangePassword) => {
  // const { new_password, current_password } = data;

  const updatePass = {
    oldPassword: data.old_password,
    newPassword: data.new_password,
  };

  return api.put(`/user/update-password`, updatePass);
};

interface IVerificationLogin {
  password?: string;
  userName: string;
}

export const verificantionLogin = (data: IVerificationLogin) => {
  const login = {
    password: data.password,
    userName: data.userName,
  };

  return api.post('/user/verification-login', login);
};
